exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#ir-search-creditor-mailing-results .download{display:inline-block;width:100%}#ir-search-creditor-mailing-results .download a{display:inline-block}#ir-search-creditor-mailing-results .download span{color:blue;display:inline-block;padding-left:5px}#ir-search-creditor-mailing-results .download-link{float:right}#ir-search-creditor-mailing-results .download-link img{padding-right:5px}#ir-search-creditor-mailing-results .download-link .ir-search-refresh-date span{color:inherit}#ir-search-creditor-mailing-results textarea{resize:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/case/creditor_mailing/CreditorMailing.less
// module id = 1613
// module chunks = 0